var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKiraCv50Icon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_131354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8001 25.3441C19.728 25.3441 25.3441 19.728 25.3441 12.8001C25.3441 5.87224 19.728 0.256104 12.8001 0.256104C5.87224 0.256104 0.256104 5.87224 0.256104 12.8001C0.256104 19.728 5.87224 25.3441 12.8001 25.3441Z",
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5759 11.5201C24.5759 18.0251 19.3049 23.2961 12.7999 23.2961C6.29497 23.2961 1.02393 18.0251 1.02393 11.5201C1.02393 5.01514 6.29497 0.256104 12.7999 0.256104C19.3049 0.256104 24.5759 5.01514 24.5759 11.5201Z",
    fill: "#006EE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0401 11.5199C23.0401 17.175 18.4551 21.7599 12.8001 21.7599C7.14502 21.7599 2.56006 17.175 2.56006 11.5199C2.56006 5.86488 6.11078 2.18872 12.8001 2.18872C19.4893 2.18872 23.0401 5.86488 23.0401 11.5199Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5482 10.1275C3.5482 10.1275 3.31268 10.107 3.3562 9.8433C3.39972 9.57962 4.43396 5.16618 7.76964 3.84522C8.12292 3.7249 8.19972 3.67114 8.86276 3.67114H16.7424C17.4055 3.67114 17.4823 3.7249 17.8356 3.84522C21.1687 5.16362 22.2055 9.57962 22.249 9.8433C22.2925 10.107 22.057 10.1275 22.057 10.1275H3.5482Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67993 10.1121H17.9199V10.8801C17.9199 11.1617 17.6895 11.3921 17.4079 11.3921H8.19193C7.91033 11.3921 7.67993 11.1617 7.67993 10.8801V10.1121Z",
    fill: "#747878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6159 12.6721H9.98389V15.4881H15.6159V12.6721Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 18.176H14.592V18.688C14.592 18.9696 14.3616 19.2 14.08 19.2H11.52C11.2384 19.2 11.008 18.9696 11.008 18.688V18.176H7.67997C7.39837 18.176 7.16797 18.4064 7.16797 18.688V24.0077C8.86269 24.8602 10.775 25.344 12.8 25.344C14.8249 25.344 16.7372 24.8602 18.432 24.0077V18.688C18.432 18.4064 18.2016 18.176 17.92 18.176Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8103 0.256104C23.9003 0.256104 24.7451 6.8993 25.3543 8.94474L23.8516 8.39946C23.8516 8.39946 23.4164 1.21098 12.8103 1.21098H12.8001C2.19402 1.21098 1.75882 8.39946 1.75882 8.39946L0.256104 8.94474C0.865384 6.8993 1.71018 0.256104 12.8001 0.256104H12.8103Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 23.296C10.7596 23.296 8.84221 22.7764 7.16797 21.865V24.0077C8.86269 24.8602 10.775 25.344 12.8 25.344C14.8249 25.344 16.7372 24.8602 18.432 24.0077V21.865C16.7577 22.7789 14.8403 23.296 12.8 23.296Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3965 8.39941C13.3965 8.39941 14.1927 8.59909 14.2541 9.33893C14.3156 10.0788 14.3975 11.3972 14.3975 11.3972C14.3975 11.3972 14.3873 11.858 13.9905 11.858H11.6045C11.2077 11.858 11.1975 11.3972 11.1975 11.3972C11.1975 11.3972 11.2794 10.0813 11.3409 9.33893C11.4023 8.59653 12.1985 8.39941 12.1985 8.39941H13.3914H13.3965Z",
    fill: "#B7B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_131354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 25.6,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKiraCv50Icon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KIRA_CV50_Icon.51463570c0fd82ef959079c07b86c589.svg";